import React from 'react';
import { Card, Typography, Badge, Tag } from 'antd';
import { UserOutlined, LoadingOutlined } from '@ant-design/icons';

const { Text } = Typography;

const CurrentUser = ({ peerId, peerConnected, username }) => {
  const getStatusColor = (connected) => {
    return connected ? 'green' : 'orange';
  };

  const getStatusText = (connected, username) => {
    return connected ? username || 'Connected' : 'Connecting...';
  };

  return (
    <Card size="small" style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <Text>Your Name:</Text>
        <Tag 
          icon={peerConnected ? <UserOutlined /> : <LoadingOutlined />} 
          color={peerConnected ? "blue" : "orange"}
        >
          {username || 'Connecting...'} {peerId && `(${peerId.slice(0, 8)})`}
        </Tag>
      </div>
    </Card>
  );
};

export default CurrentUser;